<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in crumbList" :key="item">
        <span @click="handleLink(index)" :style="{cursor:(crumbList.length === 3 && index === 1) ? 'pointer' : 'auto'}">
          {{
            index === crumbList.length - 1 && !isNeedIn
              ? item
              : $t(`menu.${item}`)
          }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  data() {
    return {
      crumbList: ['Home page', 'label', 'Label management'],
      isNeedIn: true,
      activeRoute: []
    }
  },
  watch: {
    $route: {
      handler() {
        this.matchRouter()
      },
      deep: true
    }
  },
  methods: {
    matchRouter() {
      const routerList = [...this.$route.matched] || []
      routerList.splice(0, 1)
      this.activeRoute = routerList
      let crumbList = routerList.map(v => (v.meta.breadcrumb ? v.name : ''))
      crumbList = crumbList.filter(v => !!v)
      const crumb = this.$route.query.title
      this.isNeedIn = true
      if (crumb) {
        if (crumbList[crumbList.length - 1] === 'Template details') {
          crumbList.push(crumb)
        } else {
          crumbList.splice(crumbList.length - 1, 1, crumb)
        }
        this.isNeedIn = false
      }
      this.crumbList = crumbList
    },
    handleLink(num) {
      const linkList = this.activeRoute.filter(item=>item.meta.breadcrumb)
      if(num === 1 && linkList.length === 3){
        this.$router.push({ path:linkList[1].path})
      }
      if(num === 1 && linkList[linkList.length-1]?.path === '/content/templateDetail'){
        this.$router.push({ path:'/content/templateList'})
      }
    }
  },
  mounted() {
    this.matchRouter()
  }
}
</script>
